import { buildProps } from '@element-plus/utils'
import { affixProps } from '@element-plus/components/affix'
import type { AnchorLinkPayload } from './anchor-link'
import type { ExtractPropTypes } from 'vue'

export const anchorProps = buildProps({
  /**
   * @description selector of scroll container
   * */
  target: {
    type: String,
    default: '',
  },

  /**
   * @description bound of anchor
   * */
  bounds: {
    type: Number,
    default: 5,
  },

  /**
   * @descriptionset custom highlight anchor
   * */
  getCurrentAnchor: Function,

  /**
   * @description does anchor display dots
   * */
  showDot: {
    type: Boolean,
    default: true,
  },

  /**
   * @description style of container
   * */
  wrapperStyle: Object,

  /**
   * @description top offset of scroll container
   * */
  targetOffset: Number,

  /**
   * @description Fixed anchor
   * */
  affix: {
    type: Boolean,
    default: false,
  },

  /**
   * @description affix offset distance
   * */
  affixOffset: affixProps.offset,

  /**
   * @description affix offset position
   * */
  affixPosition: affixProps.position,

  /**
   * @description scroll direction
   */
  direction: {
    type: String,
    values: ['x', 'y'],
    default: 'y',
  },
} as const)

export const anchorEmits = {
  click: (payload: AnchorLinkPayload) => !!payload,
  change: (href: string) => typeof href === 'string',
  'affix-change': (fixed: boolean) => typeof fixed === 'boolean',
}

export type AnchorProps = ExtractPropTypes<typeof anchorProps>

export interface AnchorContext {
  registerLink: (link?: string) => void
  unregisterLink: (link?: string) => void
  scrollTo: (link?: string) => void
}
